import useNavigation from 'core/hooks/navigation/useNavigation'
import cn from 'utils/cn'
import useUrlIsAppRequest from 'core/hooks/navigation/useUrlIsAppRequest'
import FeatureIcon from 'core/components/icons/FeatureIcon'
import useTailwindBreakpoint from 'core/hooks/ui/useTailwindBreakpoint'
import { LINK_EVERLANCE_BUSINESS, LINK_EVERLANCE_HOME } from 'constants/Links'
import useAuth from 'core/hooks/auth/useAuth'
import { SamlLoginUrl } from 'constants/RouteUrls'

const PublicTopNav = () => {
  const { pathname } = useNavigation()
  const isAppRequest = useUrlIsAppRequest()
  const { isMobile } = useTailwindBreakpoint()
  const { isAuthenticated } = useAuth()

  const reportUrlRegex = new RegExp(/(shared)/g)
  const isInSharedUrl = reportUrlRegex.test(pathname)
  const teamsSelfServe =
    pathname.includes('create-team') || pathname.includes('invite-members')
  const authUrlRegex = new RegExp(/auth/g)
  const isAuthPage = authUrlRegex.test(pathname)
  const isSamlLoginPage = pathname === SamlLoginUrl
  const onInvitePage = pathname?.includes('accept-invite')

  const logoLinkURL = isAuthPage ? LINK_EVERLANCE_HOME : LINK_EVERLANCE_BUSINESS
  const hrdText = isAuthPage
    ? 'Simplify mileage and expenses'
    : onInvitePage
      ? 'Automatic mileage & expense tracking'
      : 'Company Mileage & Expense Tracker'

  if (isAppRequest || isSamlLoginPage) return null

  return isInSharedUrl || teamsSelfServe || !isAuthenticated || onInvitePage ? (
    <div
      className={cn(
        'h-[4.6rem] py-2.5 px-5 bg-white shadow-md shadow-dark-1 flex items-center gap-6 cursor-pointer Navigation',
        isMobile ? 'justify-between' : ''
      )}
      onClick={() => window.open(logoLinkURL, '_blank')}
    >
      <span className="flex items-center gap-2 md:ml-5">
        <FeatureIcon
          name="everlance-by-motus-logo"
          width={isMobile ? 110 : 160}
        />
      </span>
      <div
        className={cn('m-0 font-medium', isMobile ? 'text-right' : 'text-lg')}
      >
        {hrdText}
      </div>
    </div>
  ) : null
}

export default PublicTopNav
